import React from 'react';
import IncomingTable from "./SubComponents/IncomingTable";
import OngoingTable from "./SubComponents/OngoingTable";
import InvitationMainApp from "./Functionality/InvitationMainApp";
import {VISITOR_SUB_VIEW_MODEL} from "./Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const InvitationMain = (props) => {
    const {
        subView,
        setSubView,
        selectedList,
        setSelectedList,
        searchElement,
        setSearchElement,
        criteria,
        setCriteria,
        setBodyForExport,
        finalArray,
        setFinalArray,
        search,
        setSearch,
        modified,
        setModified
    } = props;

    const { handleSubViewChange } = InvitationMainApp({
        setSubView,
        selectedList,
        setSelectedList,
        setFinalArray,
        setSearchElement
    });

    return (
        <>
            {subView === VISITOR_SUB_VIEW_MODEL.INVITATION.ONGOING &&
            <OngoingTable
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    criteria={criteria}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    modified={modified}
                    setModified={setModified}
                />
            }

            {subView === VISITOR_SUB_VIEW_MODEL.INVITATION.INCOMING &&
                <IncomingTable
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    criteria={criteria}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    modified={modified}
                    setModified={setModified}
                />
            }
        </>
    );
};

export default InvitationMain;
